<template>
  <v-dialog v-model="dialog" max-width="600" persistent>
    <v-card>
      <v-card-title class="headline">
        Configurar preguntas de entrevista
      </v-card-title>
      <v-card-text>
        <p class="mb-4">
          Selecciona las preguntas que se responderán al avanzar de \"Entrevista Preliminar\" a \"Entrevista Jefe Área\":
        </p>
        
        <s-select-definition
          :def="defPreliminarQuestions"
          v-model="selectedQuestions"
          label="Preguntas preliminares *"
          multiple
          persistent-hint
          :hint="selectedQuestions.length === 0 ? 'Debes seleccionar al menos 1 pregunta' : `${selectedQuestions.length} pregunta(s) seleccionada(s)`"
          :error="selectedQuestions.length === 0"
          :rules="[v => (v && v.length > 0) || 'Selecciona al menos una pregunta']"
        />

        <p class="caption mt-4 grey--text">
          <v-icon x-small>mdi-information-outline</v-icon>
          Las preguntas marcadas con * son obligatorias al responder
        </p>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="cancel">Cancelar</v-btn>
        <v-btn 
          color="primary" 
          :loading="loading" 
          @click="confirm"
          :disabled="selectedQuestions.length === 0"
        >
          Aperturar convocatoria
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import _sGenParam from "@/services/General/ParameterService";
export default {
  name: "HmnQuestionsSelector",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
        defPreliminarQuestions: null,
      selectedQuestions: [],
      allQuestionsDefinition: []
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  watch: {
    dialog(newVal) {
      if (newVal) {
        // Cuando se abre el dialog, capturar las preguntas del s-select-definition
        this.$nextTick(() => {
          this.captureQuestionsFromSelect();
        });
      }
    }
  },
  methods: {
    captureQuestionsFromSelect() {
      // Buscar el s-select-definition dentro de este componente
      //const selectDef = this.$el.querySelector('[def="1661"]');
      const selectDef = this.$el.querySelector(`[def="${this.defPreliminarQuestions}"]`);
      if (selectDef && selectDef.__vue__) {
        const items = selectDef.__vue__.$data.items || selectDef.__vue__.$data.listaDefinicion || [];
        if (items.length > 0) {
          this.allQuestionsDefinition = items;
          // ✅ Emitir las preguntas cargadas al padre
          this.$emit('questions-loaded', items);        }
      }
    },
    confirm() {
      // ✅ Validación obligatoria: debe haber al menos 1 pregunta seleccionada
      if (!this.selectedQuestions || this.selectedQuestions.length === 0) {
        this.$fun.alert('Debes seleccionar al menos una pregunta para la entrevista', 'warning');
        return;
      }
      this.$emit('confirm', this.selectedQuestions);
    },
    cancel() {
      this.selectedQuestions = [];
      this.dialog = false;
      this.$emit('cancel');
    },
    reset() {
      this.selectedQuestions = [];
    }
  },
    created() {
        // Cargar preguntas del endpoint al montar el componente
        _sGenParam.search({ PrmName: "QuestionsPreliminar_RRHH" }, this.$fun.getUserID())
          .then(response => {               
             this.defPreliminarQuestions =  parseInt(response.data.PrmValue) || null;
          })
          .catch(error => {
            console.error('Error cargando preguntas preliminares:', error);
          });
    }
};
</script>

<style scoped>
.caption {
  display: flex;
  align-items: center;
  gap: 6px;
}
</style>
